import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';
import Styles from './CategoryButton.styles';


const CategoryFilter = styled(Link)`${Styles.categoryfilter}`; // prettier-ignore

/**
 * CategoryButton component
 * @property {Object} props - component props
 * @param  {bool} activebutton state of button
 * @returns {JSX}
 */
const CategoryButton = ({
  titlebutton, link, activebutton
}) => {

  return (
    <CategoryFilter activebutton={activebutton} to={link}>
      {titlebutton}
    </CategoryFilter>
  );
};

CategoryButton.propTypes = {
  activebutton: PropTypes.bool,
  link: PropTypes.string,
  titlebutton: PropTypes.string
};

export default CategoryButton;
